import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Tag = ({ label, onClick }) => {
  return (
    <TagWrapper>
      <span>{label}</span>
      <button id='closeTag' onClick={onClick}>×</button>
    </TagWrapper>
  );
};

const TagWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: #f0f0f0;
  border-radius: 4px;
  padding: 4px 8px;
  margin-right: 8px;
  margin-bottom: 8px;

  span {
    margin-right: 4px;
    font-size: 1.5rem;
    color: #000 !important;
  }

  #closeTag {
    background: none;
    border: none;
    color: #999;
    cursor: pointer;
    font-size: 2rem;
    font-weight: bold;
    padding: 0;
  }
`;

export default Tag;
